export default function HelpPage() {
  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-h2 text-black">Help Center</h1>
    </div>
  );
}
